import { checkModalSubscription, checkProviderServiceSubscription } from '../../../helper';

/**
 *
 * @param {object} serviceData
 * @param {object|null} modal
 * @param {object} config
 * @description
 *
 * Для Subscription - не выводим
 * Если в конфиге start_count = false - не выводим
 *
 * @returns {boolean}
 */
export default (serviceData, modal, config) => {
  if (serviceData && config) {
    const isSubscription = checkModalSubscription(modal);
    const { mode, provider_id } = serviceData.form;
    const isLoadingProvider = serviceData?.isLoadingProvider
    const errorProvider = serviceData?.errorProvider

    const isProviderServiceSubscription = checkProviderServiceSubscription(serviceData?.form, serviceData?.providerForm);
    const isRefill = config.refill;

    if (isSubscription) {
      return false;
    }

    if (!isRefill) {
      return false;
    }

    if (mode === 1) {
      if (isProviderServiceSubscription) {
        return false;
      }

      if (isLoadingProvider) {
        return false;
      }

      if (errorProvider) {
        return false;
      }

      if (provider_id) {
        return true;
      }
    }

    if (mode === 0) {
      return true
    }
  }

  return false;
};
